import React, { useEffect } from 'react';
import Modal from 'react-modal';
import { finalizarPedido } from 'scripts/finalizarPedido';
import { limpiarCarrito } from 'store/carritoSlice';
import { obtenerEmpresa } from '../../scripts/obtenerEmpresa';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const TransferenciaModal = ({
	mostrarModalTransferencia,
	setMostrarModalTransferencia,
	pedidoId,
	direccionId,
	fechaEnvio,
	deliveryMethod = 'delivery',
	notas,
	notasCocinera,
	cuponId,
	token,
	dispatch,
	sucursalId = null,
}) => {
	const handleTransferencia = async () => {
		try {
			await finalizarPedido(
				pedidoId,
				1,
				'',
				direccionId,
				fechaEnvio,
				deliveryMethod,
				notas,
				notasCocinera,
				cuponId,
				token,
				sucursalId,
			);
			dispatch(limpiarCarrito());
			toast.success(
				'Pedido ingresado correctamente. Se encuentra pendiente de confirmacion de pago.',
			);
		} catch (error) {
			console.error('Error al procesar el pedido:', error);
			toast.error(error.message || 'Error al procesar el pedido.');
		} finally {
			setMostrarModalTransferencia(false);
		}
	};

	const fetchEmpresa = async () => {
		try {
			await obtenerEmpresa(dispatch, sessionStorage.getItem('token'));
		} catch (e) {
			console.log(e);
		}
	};
	useEffect(() => {
		fetchEmpresa();
	}, []);

	const empresa = useSelector((state) => state.empresa || {});

	return (
		<div style={{ zIndex: '1000' }}>
			{/* Modal de Transferencia */}
			<Modal
				isOpen={mostrarModalTransferencia}
				onRequestClose={() => setMostrarModalTransferencia(false)}
				contentLabel="Datos para Transferencia"
				style={{
					content: {
						top: '50%',
						left: '50%',
						right: 'auto',
						bottom: 'auto',
						marginRight: '-50%',
						transform: 'translate(-50%, -50%)',
						width: '90%',
						maxWidth: '500px',
						padding: '20px',
						borderRadius: '10px',
					},
					overlay: { backgroundColor: 'rgba(0, 0, 0, 0.75)', zIndex: 1001 },
				}}
			>
				<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
					<h3>Datos para la Transferencia</h3>
					<p>{empresa.descripcion_transferencia}</p>
					<button
						onClick={handleTransferencia}
						style={{
							marginTop: '20px',
							padding: '10px 20px',
							fontSize: '14px',
							backgroundColor: '#99cdb6',
							color: '#fff',
							border: 'none',
							borderRadius: '5px',
							cursor: 'pointer',
						}}
					>
						Enviar
					</button>
				</div>
			</Modal>
		</div>
	);
};

export default TransferenciaModal;
